import React, { useEffect, useState } from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas }     from "@fortawesome/free-solid-svg-icons"
library.add(fas)

import QuoteBlueprintFormModal from "./QuoteBlueprintFormModal"

const FormModalManager = ({ indexUrl, enabledCategories, qlineBlueprintOptions }) => {
  const [state, setState] = useState(null)

  useEffect(() => {
    const onClick = event => {
      const trigger = event.target.closest("[data-template-open]")
      if (!trigger) return
      event.preventDefault()
      const mode = trigger.getAttribute("data-template-open")
      const id   = trigger.getAttribute("data-template-id")
      setState({ mode: mode === "edit" ? "edit" : "create", id: id ? Number(id) : null })
    }
    document.addEventListener("click", onClick)
    return () => document.removeEventListener("click", onClick)
  }, [])

  const close = () => setState(null)
  const base  = indexUrl.replace(/\/$/, "")

  return (
    <QuoteBlueprintFormModal
      isOpen                = {state !== null}
      mode                  = {state?.mode}
      blueprintId           = {state?.id}
      showUrl               = {state?.id ? `${base}/${state.id}.json` : null}
      saveUrl               = {`${base}.json`}
      updateUrl             = {state?.id ? `${base}/${state.id}.json` : null}
      enabledCategories     = {enabledCategories}
      qlineBlueprintOptions = {qlineBlueprintOptions}
      onClose               = {close}
      onSaved               = {() => window.location.reload()}
    />
  )
}

export default FormModalManager
